import type { BaseSliceState } from '../types'

export interface UserDataState extends BaseSliceState {
  uid: string | null
  initialized: boolean
}

export enum UserDataActionTypes {
  USER_DATA_INIT = 'userData/init',
  USER_DATA_READY = 'userData/ready',
  USER_DATA_RESET = 'userData/reset',
  USER_DATA_ERROR = 'userData/error'
}

export type UserDataAction =
  | { type: UserDataActionTypes.USER_DATA_INIT; payload: string }
  | { type: UserDataActionTypes.USER_DATA_READY }
  | { type: UserDataActionTypes.USER_DATA_RESET }
  | { type: UserDataActionTypes.USER_DATA_ERROR; payload: string }
